import { getAuthAxiosInstance as authAxios } from './axios';
import { CreateAddressBookEntry } from '../types/addressBook';
import { REACT_APP_BACKEND_URL } from '../utils/constants';

export const getAddressBook = async (page: number = 1, limit: number = 10) => {
    return authAxios()?.get(`${REACT_APP_BACKEND_URL}/address-book`, {
        params: {
            page,
            limit
        }
    });
};

export const createAddressBookEntry = async (entry: CreateAddressBookEntry) => {
    return authAxios()?.post(`${REACT_APP_BACKEND_URL}/address-book`, entry);
};

export const updateAddressBookEntry = async (id: string, entry: Partial<CreateAddressBookEntry>) => {
    return authAxios()?.put(`${REACT_APP_BACKEND_URL}/address-book/${id}`, entry);
};

export const deleteAddressBookEntry = async (id: string) => {
    return authAxios()?.delete(`${REACT_APP_BACKEND_URL}/address-book/${id}`);
};
